// extracted by mini-css-extract-plugin
export default {"mark-all-btn":"MarkAllReadButton_mark-all-btn__1dmjl"};